import { useMemo } from "react";
import useDetectKeelMind from "./useDetectKeelMind";

function useKeelLogoSwitch(dark = false, backgroundState = false) {
    const isKeelMind = useDetectKeelMind();
    return useMemo(() => {
        if (isKeelMind) {
            return {
                logoSrc: `/images/keel-mind-logo-${
                    dark && !backgroundState ? "blue" : "white"
                }.svg`,
                logoHref: `/mind`,
            };
        } else if (window.location.pathname.includes("lab")) {
            return {
                logoSrc: `/images/keel-lab-logo-${
                    dark && !backgroundState ? "blue" : "white"
                }.svg`,
                logoHref: `/lab`,
            };
        } else {
            return {
                logoSrc: `/images/keel-logo-${
                    dark && !backgroundState ? "blue" : "white"
                }.svg`,
                logoHref: `/`,
            };
        }
    }, [backgroundState, dark, isKeelMind]);
}

export default useKeelLogoSwitch;
